__turbopack_context__.v({
  "item": "ComponentDatasheetProductVariants-module-scss-module__sri1Fq__item",
  "label": "ComponentDatasheetProductVariants-module-scss-module__sri1Fq__label",
});
